import { Occupations as UATOccupations } from "../constants/occupations.uat";
import { Occupations as ProdOccupations } from "../constants/occupations.prod";

let Occupations = process.env.REACT_APP_ENVIRONMENT === "production" ? ProdOccupations : UATOccupations;

export default Occupations;
